import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../contact-us/contact-us.service';
import Swal from 'sweetalert2';

@Component ({
    selector: 'app-estate-ar',
    templateUrl: './estate-ar.component.html',
    styleUrls: [
        '../estate-en/estate-en.component.scss',
        './estate-ar.component.scss'
    ],
    standalone: false
})
export class EstateArComponent implements OnInit {
  updateForm: UntypedFormGroup;
  submitted: boolean;

  ngOnInit(): void {
    this.initForm ();
  }

  constructor(
      private builder: UntypedFormBuilder,
      private contactService: ContactUsService) {

  }

  scroll(el: HTMLElement) {
    el.scrollIntoView ({behavior: 'smooth'});
  }

  initForm(): void {
    this.updateForm = this.builder.group (
        {
          phone: ['', Validators.required],
          name: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
          notes: ['', [Validators.required, Validators.minLength (20)]]
        },
        onblur
    );
  }

  isFieldValid(field: string): boolean {
    return (
        !this.updateForm.get (field).valid && this.updateForm.get (field).touched
    );
  }

  onSubmit(): void {
    if ( this.updateForm.valid ) {
      this.submitted = true;
      const popup = {
        title: 'لقد تم ارسال استفسارك بنجاح',
        text: 'سيتم التواصل معك في اقرب وقت ممكن',
        button: 'تم',
      };

      this.contactService.sendMail (this.updateForm.value).subscribe (
          (res) => {
            Swal.fire ({
              title: popup.title,
              text: popup.text,
              icon: 'success',
              confirmButtonText: popup.button,
            }).then (() => {
              this.submitted = false;
              this.updateForm.reset ();
            });
          },
          (err) => {
            console.log (err);
            this.submitted = false;
          }
      );
    }
  }

}
